import React from "react";
import { z } from "zod";
import { Blade } from "../../../components/Blade";
import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { Icon } from "../../../components/Icon";
import { Marquee } from "./Marquee";
import { BladeCommonSchema } from "../../../types";
export const TickerBannerPropsSchema = BladeCommonSchema.extend({
    title1: z.string(),
    title2: z.string(),
    subtitle: z.string(),
});
export const TickerBannerContractSchema = TickerBannerPropsSchema.extend({
    type: z.literal("textMarquee"),
});
const _TickerBanner = ({ title1, title2, subtitle, className, ...props }) => {
    return (React.createElement(Blade, { className: className, "data-testid": "ticker-banner", ...props },
        React.createElement(Marquee, { direction: "left", className: "top-banner", speed: 100 },
            React.createElement("span", { className: "decorated" },
                React.createElement("div", { className: "main" }, title1),
                React.createElement("div", { className: "accent" },
                    React.createElement(Icon, { name: "marqueeArrowRight" }))),
            React.createElement("span", { className: "undecorated" }, title2)),
        React.createElement(Marquee, { direction: "right", className: "bottom-banner", speed: 50 },
            React.createElement("div", { className: "decoration" }),
            React.createElement("span", null, subtitle))));
};
export const TickerBanner = styled(_TickerBanner) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=TickerBanner.js.map